module.exports = __webpack_public_path__ + "img/tooth9.34ece0af.png";